/**
 * Normaliza URLs de ficheros devueltas por la API (PDF/XML, etc.).
 * Si vienen relativas (p. ej. accounting/invoices/foo.pdf), las resuelve contra el
 * origen de VITE_API_WH sin el sufijo /api/v1. Si ya son http(s), se devuelven igual.
 */
export function resolveApiAssetUrl(url: string | null | undefined): string | null {
  if (url == null || typeof url !== 'string') {
    return null;
  }
  const trimmed = url.trim();
  if (!trimmed) {
    return null;
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  if (trimmed.startsWith('//')) {
    return `https:${trimmed}`;
  }

  const apiBaseUrl = import.meta.env.VITE_API_WH as string | undefined;
  if (!apiBaseUrl) {
    return trimmed;
  }

  const originBase = apiBaseUrl.replace(/\/api\/v1\/?$/i, '').replace(/\/$/, '');
  const path = trimmed.replace(/^\/+/, '');
  return `${originBase}/${path}`;
}
